import * as React from 'react';
import { Alert, Button, Col, Row, Space } from "antd";
import { SyncOutlined } from "@ant-design/icons";

interface SyncQueueFetchErrorProps {
  syncing: boolean;
  hasFetchError: boolean;
  errorMessage?: string;
  errorIsConnectivity?: boolean;
  syncCallback: Function;
}

export default function SyncQueueError(props: SyncQueueFetchErrorProps) {
  const { syncing, hasFetchError, errorMessage, errorIsConnectivity, syncCallback } = props;

  if (hasFetchError) {
    // Only a genuine connectivity failure is announced as a network problem.
    // When the server answered and rejected the tree, its reason is shown as is:
    // telling a planter to "try again later" while the server keeps refusing the
    // same tree leaves them stuck with a queue that never empties.
    const isConnectivity = errorIsConnectivity !== false;

    return (
      <Row>
        <Col>
          <Alert
            message={isConnectivity ? 'Network error' : 'Sync failed'}
            description={isConnectivity
              ? 'Sync was paused due to a network problem, please try again later'
              : `The server refused this tree: ${errorMessage}`
            }
            type="warning"
            showIcon
            action={
              <Space direction="vertical">
                <Button size="small" type="primary" onClick={() => syncCallback()}>
                  <SyncOutlined/> Retry
                </Button>
              </Space>
            }
          />
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row>
        <Col span={24} style={{ padding: '10px 0px' }}>
          <Button
            type='primary'
            block
            loading={syncing}
            onClick={() => syncCallback()}
          >
            <SyncOutlined/> Sync all trees
          </Button>
        </Col>
      </Row>
    </>
  );
}